import { URLS } from '@/constants'
import { getImageBySize } from '@/context/production-details/utils'
import type { CatalogAsset, Metadata, Venue } from '@/types/app-types'

export const getMetadata = (venue?: Venue, assets?: CatalogAsset[]): Metadata => {
    const metadata: Metadata = {}
    if (venue) {
        metadata.description = getMetadataDescription(venue)
        metadata.image = getMetadataImage(venue, assets)
        metadata.keywords = getMetadataKeywords(venue)
        metadata.title = getMetadataTitle(venue)
        metadata.url = getMetadataUrl(venue)
    }
    return metadata
}

const getMetadataUrl = (venue: Venue): string | null => {
    return venue.webPath ? `${URLS.VIVIDSEATS}${venue.webPath}` : null
}

const getMetadataDescription = (venue: Venue): string | undefined => {
    return `Find ${venue.name}, events and information.  View the ${venue.name} maps and ${venue.name} seating charts for ${venue.name} in ${venue.city}, ${venue.state} ${venue.postalCode}.`
}

const getMetadataImage = (venue: Venue, assets?: CatalogAsset[]): string | null => {
    if (venue.imageUrl) {
        return venue.imageUrl
    }

    if (!assets || assets.length === 0) {
        return null
    }
    const asset = assets.find((asset) => asset.id === venue.id)
    return getImageBySize(asset?.images, 'mobile')?.path || null
}

const getMetadataKeywords = (venue: Venue): string => {
    return `${venue.name} tickets, ${venue.name} seating chart`
}

const getMetadataTitle = (venue: Venue): string => {
    return `${venue.name} Tickets - ${venue.name} Information - ${venue.name} Seating Chart`
}

export const getPageTitle = (venue: Venue | undefined): string => {
    const isParking = venue?.name.toLowerCase().endsWith('parking') ?? true
    return `${venue?.name ?? ''}${isParking ? '' : ' Tickets'}`
}
